export const isTempID = (id: string): boolean => /^temp_/.test(String(id));
export const isPersistedID = (id: string): boolean => !!id && !isTempID(id);
